import type { ParsedLayout } from './dynamic-layout-parser/types/dynamic-layout-section';

export const getFirstFoldableSectionIdx: (parsedAnswer: ParsedLayout) => number = (parsedAnswer: ParsedLayout) => {
	let firstFoldableSectionIdx = -1;
	for (let i = 0; i < parsedAnswer.length; i++) {
		if (parsedAnswer[i].attributes?.hasOwnProperty('folded')) {
			firstFoldableSectionIdx = i;
			break;
		}
	}

	return firstFoldableSectionIdx;
};
